/* Sunny hero lifecycle: initialize on page load and Theme Editor replacement. */
(() => {
  'use strict';
  const cleanups = new WeakMap();
  function heroes(root) {
    const found = [...root.querySelectorAll('[id^="SunnyHero-"]')];
    if (root.matches?.('[id^="SunnyHero-"]')) found.push(root);
    return found;
  }
  function initHero(slider) {

    if (!slider || slider.dataset.initialized === 'true') {
      return;
    }

    slider.dataset.initialized = 'true';
    const abort = new AbortController();
    const on = (target, name, callback) => target.addEventListener(name, callback, { signal: abort.signal });

    const track = slider.querySelector('.sunny-hero__track');
    const slides = Array.from(
      slider.querySelectorAll('.sunny-hero__slide')
    );

    const prevButton = slider.querySelector(
      '.sunny-hero__arrow--prev'
    );

    const nextButton = slider.querySelector(
      '.sunny-hero__arrow--next'
    );

    const dots = Array.from(
      slider.querySelectorAll('.sunny-hero__dot')
    );

    if (!track || slides.length <= 1) {
      return;
    }


    let currentSlide = 0;
    let autoplayTimer = null;
    cleanups.set(slider, () => { stopAutoplay(); abort.abort(); });

    const autoplay =
      slider.dataset.autoplay === 'true';

    const pauseOnHover =
      slider.dataset.pauseHover === 'true';

    const speed =
      parseInt(slider.dataset.speed, 10) || 5000;


    function updateSlider(index) {

      if (index < 0) {
        index = slides.length - 1;
      }

      if (index >= slides.length) {
        index = 0;
      }

      currentSlide = index;

      track.style.transform =
        `translateX(-${currentSlide * 100}%)`;

      dots.forEach((dot, dotIndex) => {

        if (dotIndex === currentSlide) {
          dot.classList.add('is-active');
        } else {
          dot.classList.remove('is-active');
        }

      });

    }


    function nextSlide() {
      updateSlider(currentSlide + 1);
    }


    function previousSlide() {
      updateSlider(currentSlide - 1);
    }


    function stopAutoplay() {

      if (autoplayTimer) {
        clearInterval(autoplayTimer);
        autoplayTimer = null;
      }

    }


    function startAutoplay() {

      stopAutoplay();

      if (!autoplay) {
        return;
      }

      autoplayTimer = setInterval(
        nextSlide,
        speed
      );

    }


    if (nextButton) {

      on(nextButton, 'click', () => {
        nextSlide();
        startAutoplay();
      });

    }


    if (prevButton) {

      on(prevButton, 'click', () => {
        previousSlide();
        startAutoplay();
      });

    }


    dots.forEach((dot) => {

      on(dot, 'click', () => {

        const index =
          parseInt(dot.dataset.dot, 10);

        updateSlider(index);
        startAutoplay();

      });

    });


    on(slider, 'sunny:step', event => {
      if (event.detail.forward) nextSlide();
      else previousSlide();
      startAutoplay();
    });

    /* Touch and trackpad gestures handled by sunny-swipe.js. */

    /*
      Pause when customer hovers over banner
    */

    if (pauseOnHover) {

      on(slider, 
        'mouseenter',
        stopAutoplay
      );

      on(slider, 
        'mouseleave',
        startAutoplay
      );

    }


    /*
      Pause slider when browser tab is hidden
    */

    on(document, 
      'visibilitychange',
      () => {

        if (document.hidden) {
          stopAutoplay();
        } else {
          startAutoplay();
        }

      }
    );


    /*
      Shopify Theme Editor support
    */

    on(document, 
      'shopify:block:select',
      (event) => {

        const selectedSlide =
          event.target.closest('.sunny-hero__slide');

        if (!selectedSlide) {
          return;
        }

        const index =
          slides.indexOf(selectedSlide);

        if (index >= 0) {
          stopAutoplay();
          updateSlider(index);
        }

      }
    );


    on(document, 
      'shopify:block:deselect',
      () => {
        startAutoplay();
      }
    );


    updateSlider(0);
    startAutoplay();

  
  }
  window.sunnyInitHeroes = root => heroes(root).forEach(initHero);
  window.sunnyDisposeHeroes = root => heroes(root).forEach(hero => {
    cleanups.get(hero)?.();
    cleanups.delete(hero);
    delete hero.dataset.initialized;
  });
})();
